<template>
	<div class="public-tool-demo-app-root">
		<PublicToolDemoShell/>
		<dialogs-wrapper transition-name="modal"/>
	</div>
</template>

<script>
import PublicToolDemoShell from "@/core/modules/coach/Resources/CoachingTools/GenericTools/PublicDemo/PublicToolDemoShell.vue";

export default {
	name: "PublicToolDemoApp",
	components: {PublicToolDemoShell},
}
</script>
